export default __webpack_public_path__ + "static/media/img-0234-australia-full-face.805a60be.png";